import c1 from '../assets/jpg/c1.jpg'
import c2 from '../assets/jpg/c2.jpg'
import c3 from '../assets/jpg/c3.jpg'
// import c4 from '../assets/jpg/c4.jpg'
import c5 from '../assets/jpg/c5.jpg'
// import c6 from '../assets/jpg/c6.jpg'
import c7 from '../assets/jpg/c7.jpg'
import c8 from '../assets/jpg/c8.jpg'
import c9 from '../assets/jpg/c9.jpg'
import c10 from '../assets/jpg/c10.jpg'
import c11 from '../assets/jpg/c11.jpg'
import c12 from '../assets/jpg/c12.jpg'
export const achievementData = {
    bio :  "To embrace a truly creative life, we must courageously relinquish our fear of being wrong. It's within these moments of uncertainty that innovation and true artistry flourish",
    achievements : [
        {
            id : 1,
            title : 'Coding Profile',
            details : 'Completed 500+ problems on LeetCode, demonstrating proficiency in algorithms and data structures.',
            date : 'Jan  2021',
            field : 'Coding',
            image : c11
        },
        {
            id : 2,
            title : ' Coordinator of E-cell IIIT',
            details : 'Championed the E-CELL initiative at IIITT,engaging 150+ students and orchestrating 3+ entrepreneurship events',
            date : ' 2021-Present',
            field : 'E-Cell',
            image : c12
        },
        {
            id : 2,
            title : ' Educational Youtube Channel(Gyan Dhara ) & Running Offline counselling' ,
            details : ' Pioneered a offline college Counseling Center and YouTube channel, Gyan Dhara with 1.8K subscribers and 100+ videos.',
            date : 'Apr 2020-present',
            field : 'Education',
            image : c10
        },
        {
            id : 3,
            title : 'Selected for RashtrapatiPuraskar',
            details : 'Achieved prestigious Rajay Puraskar and selected for Rashtrapati Puraskar the highest award in the Scouts and Guides.',
            date : 'jully 2017',
            field : 'Scout',
            image : c3     
        },
      {
            id : 4,
            title : 'School Game federatation of India',
            details : 'Got gold medal in kv nationals and selected for SGFI and got 5th position all over india .',
            date : ' 2015',
            field : 'Sport',
            image : c7
        },
       
        {
            id : 6,
            title : 'High jump,Long Jump,600M',
            details : 'Got Bronze medal in kv Regonal Level  held at  K V NDA Pune.',
            date : ' 2015',
            field : 'Sport',
            image : c5
        },
        {
            id : 7,
            title : 'Bhasha Ratan ',
            details : 'Cleared  in First Shrenni.',
            date : ' 2017',
            field : 'Language',
            image : c8
        }

    ]
}


